import axios from 'axios'
import store from '@/store'
import apiErrorHandler from '../utils/apiErrorHandler'

async function getCompanies({
    page = 1,
    companyType = null,
    registerComplete = '-1',
    query = null,
    dateInit = null,
    dateEnd = null,
    partner = null,
    attachedContract = null,
    expirationInit = null,
    expirationEnd = null,
    economicGroupId = null,
    noBuyer = false,
    isActive = null
}) {
    try {
        //store.commit('user/setLoading', true)
        const result = await axios.get(`${process.env.VUE_APP_ROOT_API}/clients/v1/cadastro`, {
            headers: {
                Authorization: `Bearer ${store.state.user.token}`
            },
            params: {
                page,
                companyType,
                registerComplete: registerComplete == '-1' ? null : registerComplete,
                query,
                dateInit,
                dateEnd,
                partnerId: partner,
                attachedContract,
                expirationInit,
                expirationEnd,
                economicGroupId,
                noBuyer,
                isActive
            }
        })
        //store.commit('user/setLoading', false)

        const dataWithPartner = result.data.payload.rows.map(row => {
            if (!(row.cnpj.companyType === "0")) {
                const partners = [...new Set(row.economicGroups?.map(e => e.partnerId) || [])]
                return {
                    ...row,
                    partners
                }
            } else {
                return row
            }
        })        
        store.commit('companies/setCompanies', dataWithPartner)
        store.commit('companies/setCompaniesPagination', result.data.payload.pagination)
        return result
    } catch (e) {
        store.commit('companies/setCompanies', [])
        apiErrorHandler(e.response)
        return e.response
    }

}

export default getCompanies